/* eslint-disable import/prefer-default-export */
import { pipe, prop } from 'ramda';

export const npsSelector = (state) => state.nps;

export const isNPSApplicableSelector = pipe(
  npsSelector,
  prop('isNPSApplicable')
);
